import ConfirmationModal from 'components/Modals/ConfirmationModal';
import SearchBar from 'components/SearchBar/SearchBar';
import useSearch from 'hooks/useSearch';
import { Button } from 'react-bootstrap';
import { FaX } from 'react-icons/fa6';
import Popup from 'reactjs-popup';
import { useGetAllRolesQuery } from 'services/roles/roles.api';

export default function ImportMSRoles({
  msGroups,
  linkMulti,
  setLinkMulti,
  showConfirmLinkRoles = false,
  setShowConfirmLinkRoles,
  newRoles,
  setNewRoles,
  sendImportRoles,
}) {
  const searchFilter = useSearch();
  const { data: allRoles = [] } = useGetAllRolesQuery();

  return (
    <>
      {allRoles && allRoles.length > 0 && (
        <div className="d-flex flex-column z-1">
          <div className="p-2 mb-2">
            <SearchBar className="bg-primary rounded-3 w-100" placeholder={'Search'} />
          </div>
          <div className="flex-row align-items-center justify-content-around align-content-center gap-2 mb-2">
            <div className="">Microsoft Security Group:</div>
            <div className="">Fusion Roles:</div>
            <div className=""></div>
          </div>
          <div className="d-flex align-content-center align-items-center gap-2">
            <div className="customScrollbar-Y d-flex flex-column w-100 h-lg overflow-auto">
              {msGroups
                .sort((a, b) => {
                  return a.displayName.localeCompare(b.displayName);
                })
                .filter((group) => {
                  return (
                    group.displayName.toLowerCase().includes(searchFilter.toLowerCase()) ||
                    (linkMulti[group.id] &&
                      linkMulti[group.id]
                        .map((role) => {
                          return allRoles.find((r) => r.role_Id === role)?.role_name;
                        })
                        .join(', ')
                        .toLowerCase()
                        .includes(searchFilter.toLowerCase()))
                  );
                })
                .map((group, i) => {
                  return (
                    <div
                      className="d-grid p-2 align-content-center"
                      style={{
                        gridTemplateColumns: '1fr 0.5fr minmax(0, 1fr)',
                        background: i % 2 === 0 ? '' : '#2c373b',
                      }}
                      key={i}
                    >
                      <div className="text-break text-wrap me-1">{group.displayName}</div>
                      {!allRoles.map((i) => i.role_name).includes(group.displayName) ? (
                        <div className="d-flex flex-row align-items-center gap-2 pe-2">
                          Create New Role?
                          <input
                            type="checkbox"
                            value={newRoles.filter((f) => f.name === group.displayName).length > 0}
                            onChange={(e) => {
                              let newArr = [...newRoles];
                              if (e.target.checked)
                                newArr.push({
                                  name: group.displayName,
                                  id: group.id,
                                });
                              else
                                newArr.splice(
                                  newArr.findIndex((f) => f.name === group.displayName),
                                  1,
                                );

                              setNewRoles(newArr);
                            }}
                          />
                        </div>
                      ) : (
                        <div className="text-light">{/* Role already exists */}</div>
                      )}
                      <div className="d-flex align-content-center gap-1">
                        {newRoles.filter((f) => f.name === group.displayName).length > 0 && (
                          <div
                            className="d-flex flex-row m-auto px-1 bg-primary fs-6 rounded gap-2 border-1 border border-light-subtle col-10"
                            style={{ height: 24 }}
                          >
                            <div className="inline-block flex-nowrap text-nowrap overflow-hidden text-truncate">
                              {group.displayName}
                            </div>
                          </div>
                        )}
                        {newRoles.filter((f) => f.name === group.displayName).length === 0 && (
                          <Popup
                            trigger={
                              <div
                                className="d-flex flex-row m-auto px-1 bg-primary fs-6 border-1 border border-dark-subtle col-10 rounded-1"
                                style={{ height: 24 }}
                              >
                                <div className="inline-block flex-wrap text-nowrap overflow-hidden text-truncate rounded-1">
                                  {(() => {
                                    if (!linkMulti[group.id]) return '';
                                    const rolesString = linkMulti[group.id]
                                      .map((role) => {
                                        return allRoles.find((r) => r.role_Id === role)?.role_name;
                                      })
                                      .join(', ');
                                    return rolesString;
                                  })()}
                                </div>
                              </div>
                            }
                            position="bottom center"
                            on="hover"
                            closeOnDocumentClick={false}
                            contentStyle={{ zIndex: 'var(--z-popover)' }}
                          >
                            <div className="customScrollbar-Y flex-column align-items-start p-2 bg-primary rounded-1 cursor-pointer ms-2 h-fit max-w-3xs max-h-sm overflow-auto">
                              {allRoles &&
                                allRoles
                                  .filter((role) => {
                                    return role.role_Id >= 0;
                                  })
                                  .map((item, index) => {
                                    return (
                                      <div
                                        className="gap-2 p-1"
                                        key={index}
                                        style={{
                                          background: linkMulti[group.id]?.includes(item.role_Id)
                                            ? 'var(--color-primary)'
                                            : '',
                                        }}
                                        onClick={() => {
                                          setLinkMulti({
                                            ...linkMulti,
                                            [group.id]: linkMulti[group.id]?.includes(item.role_Id)
                                              ? linkMulti[group.id].filter(
                                                  (r) => r !== item.role_Id,
                                                )
                                              : [...(linkMulti[group.id] || []), item.role_Id],
                                          });
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          checked={linkMulti[group.id]?.includes(item.role_Id)}
                                          readOnly
                                        />{' '}
                                        {item.role_name}
                                      </div>
                                    );
                                  })}
                            </div>
                          </Popup>
                        )}
                        <div
                          className="align-content-center"
                          onClick={() => {
                            setLinkMulti({
                              ...linkMulti,
                              [group.id]: [],
                            });
                          }}
                        >
                          <FaX />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="w-100 d-flex justify-content-end align-items-center">
            <Button
              variant="primary"
              className="mt-3 bg-primary rounded"
              onClick={() => {
                setShowConfirmLinkRoles(true);
              }}
              style={{ width: 100, height: 50 }}
            >
              Sync
            </Button>
          </div>
          {showConfirmLinkRoles && (
            <>
              <style>{`.modal-superwide{max-width:40% !important;}`}</style>
              <ConfirmationModal
                show={showConfirmLinkRoles}
                handleShow={() => setShowConfirmLinkRoles(false)}
                dialogClassName="modal-superwide"
                customBodyTxtClassName={'fs-5 mb-3 w-100'}
                bodyTxt={`Important Notice:\n
      
      You are about to link a Microsoft Security Group to a Role within Overwatch Fusion+. This is a critical action that requires careful consideration.\n
      
      Once linked, all users in the selected security group will be imported into Overwatch Fusion+ and assigned the corresponding role. This role determines their access to specific permissions, widgets, and dashboard layouts within the app.\n
      
      Although this action can be reversed, we strongly recommend ensuring the security group is appropriate for the intended role and permissions before proceeding.\n
      
      By continuing, you acknowledge the significance of this action and confirm your intent to proceed with the import and role assignment.`}
                confirmBtnTxt={'Yes'}
                cancelBtnTxt={'Cancel'}
                cancelHandler={() => setShowConfirmLinkRoles(false)}
                confirmHandler={() => {
                  setShowConfirmLinkRoles(false);
                  sendImportRoles();
                }}
              />
            </>
          )}
        </div>
      )}
    </>
  );
}
